import config from '@/config';
import { requests } from '.';
const PAYMENTS_SERVICE_URL = config?.PAYMENTS_SERVICE_URL;
export var OrderSourceType;
(function (OrderSourceType) {
    OrderSourceType["MANUAL"] = "manual";
})(OrderSourceType || (OrderSourceType = {}));
export var TaxCalculation;
(function (TaxCalculation) {
    TaxCalculation["EXCLUSIVE"] = "exclusive";
})(TaxCalculation || (TaxCalculation = {}));
export const PaymentServices = {
    getTotalAmountByCustomer: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/transactions/total-amount-by-customer', { params }),
    getCurrencyDetails: () => requests(PAYMENTS_SERVICE_URL).get(`/payments/currency`),
    getAllIntegrations: (locationId) => requests(PAYMENTS_SERVICE_URL).get(`/payments/integrations/${locationId}`),
    getStripeIntegration: (locationId) => requests(PAYMENTS_SERVICE_URL).get(`/payments/integrations/stripe`, {
        params: { location_id: locationId },
    }),
    getStripeCustomerPaymentMethods: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/stripe/customer/payment-methods', { params }),
    getAuthorizeNetCustomerPaymentMethods: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/authorize-net/customer/payment-methods', { params }),
    nmiCardCustomerPaymentMethods: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/nmi/customer/payment-methods', { params }),
    initiateStripeGeneralPayment: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/stripe/initiate-general-payment', params),
    updatePaymentLink: (paymentLinkId, params) => requests(PAYMENTS_SERVICE_URL).put(`payments/payment-link/${paymentLinkId}`, params),
    updatePaymentLinkStatus: (paymentLinkId, params) => requests(PAYMENTS_SERVICE_URL).patch(`payments/payment-link/${paymentLinkId}`, params),
    createNewPaymentLink: (params) => requests(PAYMENTS_SERVICE_URL).post('payments/payment-link/new', params),
    getPaymentLinkById: (paymentLinkId) => requests(PAYMENTS_SERVICE_URL).get(`payments/payment-link/preview?paymentLinkId=${paymentLinkId}`),
    listPaymentLinks: (params) => requests(PAYMENTS_SERVICE_URL).get('payments/payment-link', { params }),
    verifyStripeGeneralPayment: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/stripe/verify-general-payment', params),
    chargeAuthorizeNetGeneralPayment: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/authorize-net/pay', params),
    chargeNMIGeneralPayment: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/nmi/pay', params),
    initiateStripeCustomerCardSetup: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/stripe/customer/initiate-card-setup', params),
    verifyStripeCustomerCardSetup: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/stripe/customer/verify-card-setup', params),
    getPaymentSettings: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/payment-settings', {
        params,
    }),
    updatePaymentSettings: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/payment-settings', params),
    getTaxes: (params) => requests(PAYMENTS_SERVICE_URL).get('/payments/taxes/', { params }),
    createTax: (params) => requests(PAYMENTS_SERVICE_URL).post('/payments/taxes/', params),
    updateTax: (params) => requests(PAYMENTS_SERVICE_URL).put('/payments/taxes/', params),
};
